import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axiosInstance from 'api/axios';
import { buildQueryString } from 'utils/general';

const initialState = {
	currentOpenDrawer: '',
	loading: false,
	allServiceList: [],
	pagination: {
		page: 1,
		limit: 10,
		totalPages: 0,
		totalResults: 0,
	},
	drawerVaues: {
		VIEW_PRODUCT_DETAILS: 'VIEW_PRODUCT_DETAILS',
		PRODUCT_FILTER: 'PRODUCT_FILTER',
	},
};

// Service Management CRUD operations API calls

export const fetchAllService = createAsyncThunk('serviceManagement/fetchAllService', async (options, { rejectWithValue }) => {
	// API call to fetch all services
	try {
		// Extract schedule if available
		const scheduleParams = options.schedule;

		const query = buildQueryString({
			search: options.search,
			type: options.type,
			startDate: options.startDate,
			endDate: options.endDate,
			isActive: options.isActive?.toString(),
			page: options.page,
			limit: options.limit,
			sortBy: options.sortBy,
			appealed: options.appealed,
			approvalStatus: options.approvalStatus,
			serviceCategory: options.categoryId,
			serviceSubCategory: options.subCategoryId,
			experience: options.experience,
			...scheduleParams,
			appealType: options.appealType,
			postedFrom: options.postedFrom,
		});

		const response = await axiosInstance.get(`/service/admin?${query}`);

		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const fetchAllRejectReasons = createAsyncThunk('serviceManagement/fetchAllRejectReasons', async (options, { rejectWithValue }) => {
	// API call to fetch all services
	try {
		const response = await axiosInstance.get(`/reject-reasons`);

		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const fetchReportedService = createAsyncThunk('serviceManagement/fetchReportedService', async (options, { rejectWithValue }) => {
	// API call to fetch all services
	try {
		const query = buildQueryString({
			search: options.search,
			// type: options.type,
			type: 'service',
			startDate: options.startDate,
			endDate: options.endDate,
			// isActive: options.isActive?.toString(),
			page: options.page,
			limit: options.limit,
			sortBy: options.sortBy,
			// appealed: options.appealed,
		});

		const response = await axiosInstance.get(`/report-item?${query}`);

		if (response.success) {
			return response;
		}

		rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const updateService = createAsyncThunk('serviceManagement/updateService', async ({ data, id, isActive }, { rejectWithValue, dispatch }) => {
	try {
		const response = await axiosInstance.patch(`/service/admin/${id}`, data);

		if (response.success) {
			const options = {
				page: 1,
				limit: 10,
				isActive,
			};

			dispatch(fetchAllService(options));

			return response;
		}

		return rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const deleteService = createAsyncThunk('serviceManagement/deleteService', async (serviceId, { rejectWithValue, dispatch }) => {
	// API call to delete a service
	try {
		const response = await axiosInstance.delete(`/service/${serviceId}`);

		if (response.success) {
			const options = {
				page: 1,
				limit: 10,
			};

			dispatch(fetchAllService(options));

			return response;
		}

		return rejectWithValue({ data: [], success: false });
	} catch (error) {
		console.error(error);
		return rejectWithValue(error.response.data);
	}
});

export const serviceManagementSlice = createSlice({
	name: 'serviceManagement',
	initialState,
	reducers: {
		setCurrentOpenDraverValueTo: (state, action) => {
			state.currentOpenDrawer = action.payload;
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchAllService.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchAllService.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.allServiceList = payload.result.data;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(fetchAllService.rejected, (state) => {
				state.loading = false;
			})
			.addCase(fetchReportedService.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchReportedService.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.allReportedServiceList = payload.result.data;
				state.pagination = {
					page: payload.result.page,
					limit: payload.result.limit,
					totalPages: payload.result.totalPages,
					totalResults: payload.result.totalResults,
				};
			})
			.addCase(fetchAllRejectReasons.rejected, (state) => {
				state.loading = false;
			})
			.addCase(fetchAllRejectReasons.pending, (state) => {
				state.loading = true;
			})
			.addCase(fetchAllRejectReasons.fulfilled, (state, { payload }) => {
				state.loading = false;
				state.allServiceRejectedReasons = payload.result;
			})
			.addCase(fetchReportedService.rejected, (state) => {
				state.loading = false;
			})
			.addCase(deleteService.pending, (state) => {
				state.loading = true;
			})
			.addCase(deleteService.fulfilled, (state) => {
				state.loading = false;
			})
			.addCase(deleteService.rejected, (state) => {
				state.loading = false;
			});
	},
});

export const { setCurrentOpenDraverValueTo } = serviceManagementSlice.actions;

export default serviceManagementSlice.reducer;
